// components/assigned-tasks/QuickNotesSection.jsx
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import DaysLeft from "../modules/days-left/days-left.component";
import Priority from "../modules/priority/priority.component";
import RetroButton from "../retro/button/retro-button.component";

import RetroInput from "../retro/input/input.component";

import {
  db,
  createNewInboxTask,
  updateInboxTaskAsDone,
  fieldValue,
} from "../../firebase/firebase.utils";

import "./assigned-tasks.styles.scss";

import { BsStickyFill, BsPlus } from "react-icons/bs";
import { PiNoteFill, PiNoteLight } from "react-icons/pi";

const QuickNotesSection = ({ color, name, notes, expandAll }) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    if (expandAll !== null) {
      setIsOpen(expandAll);
    }
  }, [expandAll]);

  const [newTaskName, setNewTaskName] = useState("");
  const inputRef = useRef();

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    createNewInboxTask(currentUser.uid, newTaskName, null);
    inputRef.current.value = "";
    inputRef.current.blur();
  };

  const handleCheck = (task, done) => {
    document.getElementById("done_tone").play();
    const IdRef = currentUser.uid;
    if (task.done) {
      updateInboxTaskAsDone(IdRef, task.id, false);
    } else {
      updateInboxTaskAsDone(IdRef, task.id, true);
      console.log("it says it is not done!");
    }
  };

  const handleOpenModal = (mode, event) => {
    navigate(`note/${event.id}`);
  };

  const handleEventClick = (task) => {
    console.log("selected task is:", task);
    // console.log("id of the selected task:", task);
    handleOpenModal(
      "edit",
      {
        id: task.id,
        title: task.title,
        description: task.description,
        done: task.done,
        startdate: task.startdate,
        enddate: task.enddate,
        allDay: task.allDay,
        duration: task.duration,
        done: task.done,
        createdBy: task.createdBy,
        createdAt: task.createdAt,
        assign: task.assign,
        phase: task.phase,
        priority: task.priority,
        progress: task.progress,
        type: task.type,
        fromSpaceId: task.fromSpaceId,
        fromStationId: task.fromStationId,
        subtasks: task.subtasks,
      },
      // events.find((e) => e.id.toString() === id.toString())
    );
  };

  return (
    <div className={`personalItem_WSDetails ${isOpen ? "open" : ""}`}>
      <button
        type="button"
        className="personalItem_WSSummary"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div className="at__fromspace-list-btn">
          <RetroButton style={{ background: "#1A82C4", color: "white" }}>
            <BsStickyFill strokeWidth="0.1" />
          </RetroButton>
          <h4>{name}</h4>
        </div>
      </button>

      <div className="wsDetailsContent">
        <div className="wsDetailsContent_Inner">
          {notes.map((task) => {
            return (
              <div
                key={task.id}
                // className="at__item"
                className="personalItem_Item"
                id={task.id}
                done={task.done}
                title={task.title}
                start={task.startdate}
                // end={task.enddate}
                // duration={task.duration}
                fromSpaceId={task.fromSpaceId}
                fromStationId={task.fromStationId}
              >
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      columnGap: "5px",
                      cursor: "pointer",
                      paddingTop: "6px",
                      paddingBottom: "6px",
                    }}
                  >
                    <div className="at__check-and-name">
                      <div
                        className="at__checkBox"
                        onClick={(id, done) => handleCheck(task, done)}
                      >
                        {task.done ? <PiNoteFill /> : <PiNoteLight />}
                      </div>
                      <audio
                        id="done_tone"
                        src="/media/mixkit-cool-interface-click-tone-2568.wav"
                      ></audio>
                      <div
                        className="at__content"
                        onClick={() => handleEventClick(task)}
                      >
                        <p>{task.title}</p>
                      </div>
                    </div>
                    {/* <div className="at__modules">
                      <div className="at__daysLeft">
                        <DaysLeft task={task} />
                      </div>
                      <div className="at__priority">
                        <Priority task={task} />
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            );
          })}
          {/* <div className="st__newTask st__newTask-inside">
            <form
              onSubmit={(e) => {
                handleSubmit(e);
              }}
            >
              <div onChange={(e) => setNewTaskName(e.target.value)}>
                <RetroInput ref={inputRef} placeholder="Add Quick Note" />
              </div>
            </form>
          </div> */}
          <button
            onClick={() =>
              navigate("addnote", {
                mode: "add",
              })
            }
            className="addQuickBtn"
          >
            <BsPlus />
            Add Quick Note
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuickNotesSection;
